import { Link } from 'react-router-dom';

export default function Forbidden() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-neutral-light-bg px-4 py-16">
      <div className="max-w-md w-full bg-white p-8 rounded-sm border border-gray-100 shadow-sm text-center space-y-6">
        <div className="w-16 h-16 rounded-full bg-red-50 text-red-600 flex items-center justify-center text-2xl mx-auto shadow-xs">
          <i className="fa-solid fa-lock" />
        </div>
        <div className="space-y-2">
          <h1 className="font-display text-2xl font-bold text-primary-green uppercase tracking-wider">
            403 - Adgang nægtet
          </h1>
          <p className="font-body text-xs text-neutral-muted leading-relaxed">
            Du har desværre ikke tilladelse til at tilgå denne side. Hvis du mener, dette er en fejl, bedes du kontakte os.
          </p>
        </div>
        <div className="pt-4">
          <Link 
            to="/" 
            className="bg-primary-green hover:bg-primary-green-light text-white font-display text-xs font-bold px-6 py-3.5 uppercase tracking-wider transition-all duration-200 rounded-sm shadow-sm inline-block w-full"
          >
            Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
